var React = require('react');

function Union (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.022 11.97h39.956v26.06H8.022V11.97zM6 40V10h44v30H6zm32 4H18v2h20v-2zm-9.147-18.95a3.266 3.266 0 0 0-1.088-6.344 3.265 3.265 0 0 0-1.088 6.344v5.627a1.088 1.088 0 1 0 2.176 0V25.05z","fill":"#5FD800"}));
}

Union.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Union;

Union.default = Union;
